<template>
  <div id="app"  class="d-flex flex-column h-100">
    <main-nav />
    <main class="flex-shrink-0">
      <transition name="slide-left" mode="out-in">
        <keep-alive>
          <router-view />
        </keep-alive>
      </transition>
    </main>
    <site-footer />
  </div>
</template>

<script>

import MainNav from '@/components/MainNav.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  data: function() {
    return {

    }

  },
  components: {
    MainNav,
    SiteFooter
  }

}


</script>

<style lang="scss">

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
